var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartsOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-943 -3254)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(943 3254)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(938.217 3247.007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.926 10.104)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.925,34.424a12,12,0,0,1-12-11.824v-.1A11.874,11.874,0,0,1,19.8,10.631h.008a1.831,1.831,0,0,1,1.79,1.834v8.589H29.8a.982.982,0,0,1,.19.018,1.826,1.826,0,0,1,1.629,1.875A11.923,11.923,0,0,1,20.244,34.419l-.134,0Zm-.346-21.773A9.858,9.858,0,0,0,9.944,22.5a9.985,9.985,0,0,0,9.981,9.907l.154,0A9.916,9.916,0,0,0,29.6,23.072H21.161a1.586,1.586,0,0,1-1.582-1.587ZM21.6,21.486v0Zm-2.018-9.032v0Z",
    transform: "translate(-7.926 -10.631)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.173 7.897)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.9,18.87H28.426a1.616,1.616,0,0,1-1.614-1.614V9.511A1.616,1.616,0,0,1,28.426,7.9h0A9.123,9.123,0,0,1,37.518,17v.276A1.615,1.615,0,0,1,35.9,18.87ZM28.83,16.852H35.5A7.1,7.1,0,0,0,28.83,9.927Z",
    transform: "translate(-26.812 -7.897)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartsOutline);
export default __webpack_public_path__ + "static/media/charts-outline.688310a77bead689f48e19543c2ff333.svg";
export { ForwardRef as ReactComponent };